import { render, staticRenderFns } from "./WhatsAppSettingsReportMedicine.vue?vue&type=template&id=49cdfca4&"
import script from "./WhatsAppSettingsReportMedicine.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSettingsReportMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports